import React, { useEffect, useState, Suspense, lazy } from "react";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import axios from "axios";
import Header from './components/Header';
import CallMeForm from './components/CallMeForm';
import Body from './components/Body';
import Footer from './components/CommenFooterComponent/index';
import "@fontsource/poppins";
import Navbar from './components/Header/index';
import './App.css';
import { CookieSetting } from "cookiesetting-component";
import Contact from './components/Contact';
import MediaQuery from 'react-responsive';
import Videos from './components/Videos';
import jsonData from "./components/ai-branding.json"; // Import the JSON file

function App() {

const appVersion = appversion.version;
const [links, setLinks] = useState(null); // Set initial state as null

useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <>
    <CacheBuster
          currentVersion={appVersion}
          isEnabled={true}
          isVerboseMode={false}
          metaFileDirectory={"."}
        >
          <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    <Navbar />
      <MediaQuery minWidth={992}>
        <Suspense fallback={<div />}>
          <div className="blue-bg">
            <Header links={links}/>
          </div>
          <div className="podcast-bg">
            <Videos />
          </div>
          <Contact />
        </Suspense>
      </MediaQuery>

      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <Header links={links}/>
          <div className="lightblue-bg">
            <Contact />
          </div>
          <Videos />
        </Suspense>
      </MediaQuery>
      <Body links={links}/>
      <Footer />
      </CacheBuster>
    </>
  );
}

export default App;